import React, { useState, useEffect, useMemo } from "react";
import { logEventos } from "../../../../services/services";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import { alpha, Box, Chip, Container, ListItemIcon, MenuItem, Typography } from "@mui/material";
import { Edit as EditIcon, FindInPage as FindInPageIcon, Assignment as AssignmentIcon, People as PeopleIcon, AddBoxTwoTone as AddBoxTwoToneIcon, AccountCircle, AccountBalance, RequestQuote, Visibility, History } from "@mui/icons-material";
import { UrlApi } from "../../../../services/apirest";
import Navbar from "../../../Navbar";
import FormRevisar from "./FormRevisar";
import ModalHistorialRechazos from "./ModalHistorialRechazos";
import { getEstadoRevisionProveedor } from "./funciones";

const CHIP_ESTILOS = {
    rechazado: (theme) => ({
        fontWeight: 600,
        bgcolor: alpha(theme.palette.error.main, 0.12),
        color: theme.palette.error.dark,
        border: `1px solid ${alpha(theme.palette.error.main, 0.24)}`,
    }),
    pendiente: (theme) => ({
        fontWeight: 600,
        bgcolor: alpha(theme.palette.warning.main, 0.12),
        color: theme.palette.warning.dark,
        border: `1px solid ${alpha(theme.palette.warning.main, 0.24)}`,
    }),
    revisado_compras: (theme) => ({
        fontWeight: 600,
        bgcolor: alpha(theme.palette.info.main, 0.12),
        color: theme.palette.info.dark,
        border: `1px solid ${alpha(theme.palette.info.main, 0.24)}`,
    }),
    revisado_impuestos: (theme) => ({
        fontWeight: 600,
        bgcolor: alpha(theme.palette.secondary.main, 0.12),
        color: theme.palette.secondary.dark,
        border: `1px solid ${alpha(theme.palette.secondary.main, 0.24)}`,
    }),
    aprobado: (theme) => ({
        fontWeight: 600,
        bgcolor: alpha(theme.palette.success.main, 0.12),
        color: theme.palette.success.dark,
        border: `1px solid ${alpha(theme.palette.success.main, 0.24)}`,
    }),
};

export default function Listados_pendientes(params) {
    const [proveedores, setProveedores] = useState([]);
    const [editar, setEditar] = useState(false);
    const [formData, setformData] = useState({});
    const [tabla, settabla] = useState(true);
    const [historialOpen, setHistorialOpen] = useState(false);
    const [historialCuit, setHistorialCuit] = useState(null);

    const sinIibbCabecera = (row) => {
        if (!row || typeof row !== "object") return row;
        const { coeficiente, vigencia, vigencia_date, ...resto } = row;
        return resto;
    };

    const getProveedores = async () => {
        await fetch(UrlApi + '/proveedores/h/para_revisar')
            .then((data) => data.json())
            .then((data) =>
                setProveedores(
                    Array.isArray(data) ? data.map((row) => sinIibbCabecera(row)) : data
                )
            );
    };

    useEffect(() => {
        getProveedores()
    }, [])

    const muiSearchTextFieldProps = {
        placeholder: "Buscar..",
        sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
        variant: "outlined",
        color: "primary",
        size: "small",
    };

    const initialState = {
        density: "compact",
        showGlobalFilter: true,
        pagination: {
            pageSize: 10,
            pageIndex: 0,
        },
    };

    const tableHeadCellProps = {
        align: "left",
        sx: {
            fontSize: 16,
            color: "white",
            fontWeight: "normal",
            backgroundColor: "#2471A3",
            borderColor: "black",
        },
    };

    const columns = useMemo(
        () => [
            { header: "Razon Social", accessorKey: "razon_social" },
            { header: "CUIT", accessorKey: "nro_cuit" },
            {
                id: "estado",
                header: "Estado",
                accessorFn: (row) => getEstadoRevisionProveedor(row).label || "",
                size: 220,
                enableSorting: true,
                Cell: ({ row }) => {
                    const estado = getEstadoRevisionProveedor(row.original);

                    if (!estado.key || !estado.label) {
                        return (
                            <Typography variant="caption" color="text.secondary">
                                —
                            </Typography>
                        );
                    }

                    return (
                        <Chip
                            label={estado.label}
                            size="small"
                            sx={(theme) =>
                                CHIP_ESTILOS[estado.key]?.(theme) || CHIP_ESTILOS.pendiente(theme)
                            }
                        />
                    );
                },
            },
        ],
        []
    );

    useEffect(() => {
        logEventos(
            "acceso al menú  Proveedores",
            "Tablas Referencias",
            "Proveedores",
            localStorage.getItem("user"));
    }, []);

    const handleEditar = (data) => {
        setEditar(true);
        setformData(sinIibbCabecera(data));
        settabla(false);
    };

    return (
        <div>
            <Navbar />
            <Container disableGutters maxWidth="xl">
                {tabla && (
                <Box
                    boxShadow={3}
                    mb={5}
                    sx={{
                        paddingLeft: "30px",
                        paddingRight: "30px",
                        paddingTop: "20px",
                    }}
                >
                        <MaterialReactTable
                            columns={columns}
                            enableColumnResizing
                            data={proveedores}
                            initialState={initialState}
                            localization={MRT_Localization_ES}
                            muiSearchTextFieldProps={muiSearchTextFieldProps}
                            muiTableHeadCellProps={tableHeadCellProps}
                            muiTableBodyCellProps={{
                                align: "left",
                                sx: {
                                    color: "black",
                                    borderColor: "black",
                                },
                            }}
                            muiTableBodyRowProps={({ row }) => ({
                                sx: (theme) => ({
                                    backgroundColor:
                                        row.index % 2 === 0
                                            ? theme.palette.background.paper
                                            : theme.palette.action.hover,
                                }),
                            })}
                            enableExpandAll={false}
                            // enableGlobalFilter={true}
                            enableToolbarInternalActions={true}
                            layoutMode="grid"
                            enableColumnActions={false}
                            enableColumnFilters={false} //desactiva filtros x  columna
                            enableHiding={false}
                            enableDensityToggle={false} //
                            enableColumnDragging={false} //No permite que se arrastren las columnas.
                            enableStickyFooter
                            enableRowActions
                            positionActionsColumn="last"
                            // enableGlobalFilterModes={true}
                            // enableStickyHeader
                            enableGlobalFilter={true}
                            enableFullScreenToggle={false}
                            renderTopToolbarCustomActions={() => (
                                <Typography variant="poster" fontSize={26}>
                                    Proveedores
                                </Typography>
                            )}
                            renderRowActionMenuItems={({ closeMenu, row }) => [
                                <MenuItem
                                    key="revisar"
                                    onClick={() => {
                                        handleEditar(row.original);

                                        closeMenu();
                                    }}
                                >
                                    <ListItemIcon>
                                        <Visibility color="primary" />
                                    </ListItemIcon>
                                    Revisar Datos
                                </MenuItem>,
                                <MenuItem
                                    key="historial-rechazos"
                                    onClick={() => {
                                        setHistorialCuit(row.original?.nro_cuit ?? null);
                                        setHistorialOpen(true);
                                        closeMenu();
                                    }}
                                >
                                    <ListItemIcon>
                                        <History color="primary" />
                                    </ListItemIcon>
                                    Ver historial de rechazos
                                </MenuItem>,
                            ]}
                        />
                </Box>
                )}
                {editar && (
                    <FormRevisar
                        open={editar}
                        setopen={setEditar}
                        data={formData}
                        tabla={settabla}
                        actualizar={getProveedores}
                    />
                )}
                <ModalHistorialRechazos
                    open={historialOpen}
                    onClose={() => {
                        setHistorialOpen(false);
                        setHistorialCuit(null);
                    }}
                    nroCuit={historialCuit}
                />
            </Container>
        </div>
    )
}